import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Loader from '../components/Loader'

import { lambda, setSecureCookie } from '../Functions';


export default function Signup() {

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');


  
  const handleSignup = async () => {
    setLoading(true);
    setError('');

    console.log(JSON.stringify({ email, password , firstName , lastName , phonenumber }))

        try {
          const response = await fetch(`${lambda}?action=signup`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password , firstName , lastName, phonenumber })
          }).then(res => res.json())
            .then(data => {
              console.log(data);
    
              if (data.error) {
                setError(data.message);
              } else {
              
                setSecureCookie("gbx_id" ,data.user.id,7 )
                sessionStorage.setItem("gbx_data" , JSON.stringify(data))
                window.location.href='/profile/settings'
              }
            })
    
        } catch (err) {
          console.error("Error signing in:", err);
    
        } finally {
          setLoading(false);
        }

  };

  return (
    <div>
      <Navbar />
      <section className=" d-flex flex-column align-items-center justify-content-center" >
        <div className=" auth_form bg_purple_light mt-12 p-6" >
          <h2 className="pb-4">Sign Up</h2>
          {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>} {/* Display error */}

          <div className="row">
            <div className="col-sm-6">
              <div className="d-flex flex-column">
                <label className="bold">First Name</label>
                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              </div>
            </div>

            <div className="col-sm-6">
              <div className="d-flex flex-column">
                <label className="bold">Last Name</label>
                <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>
          </div>

          <div className="d-flex flex-column mt-4">
            <label className="bold">Phone : </label>
            <input type="text" value={phonenumber} onChange={(e) => setPhonenumber(e.target.value)} />
          </div>
          <div className="d-flex flex-column mt-4">
            <label className="bold">Email Address:</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="d-flex flex-column mt-3">
            <label className="bold">Password:</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          <p className="text-dark mt-3">
            Already have an account?{' '}
            <span className="bold" style={{ cursor: 'pointer' }} onClick={() => window.location.href = "/signin"}>
              Sign In
            </span>
          </p>

          <button
            className="home_button_purple mt-4"
            style={{ width: '150px', float: 'right' , fontSize:'1.5rem' }}
            onClick={()=>handleSignup()}
            disabled={loading}
          >
            {loading ?  <p>Sign in <Loader/></p> : 'Sign Up'}
          </button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
